import { useState } from 'react';
import TrackingSearch from './components/TrackingSearch/TrackingSearch'
import SuggestionsCarousel from './components/SuggestionsCarousel/SuggestionsCarousel';
import ServiceRequestModal from './components/ServiceRequestModal/ServiceRequestModal';
import TopLogo from './moros-logo.jpg';
import BottomLogo from './einterior-logo.jpg';
import './App.css';

function App() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleEInteriorClick = () => {
    window.location.href = "https://e-interior.gr/";
  }

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);
  
  return (
    <div className="App">
      <div className="App-container">
        <img 
          src={TopLogo} 
          className="App-logo" 
          alt="Moros Design House" 
          onClick={handleEInteriorClick}
        />
        
        {/* Service Request Section */}
        <div className="service-request-section">
          <p className="service-request-text">
            Μπορείτε να υποβάλετε ένα αίτημά σας άμεσα και θα επικοινωνήσουμε μαζί σας!
          </p>
          <button className="service-request-btn" onClick={openModal}>
            ΥΠΟΒΟΛΗ ΑΙΤΗΜΑΤΟΣ
          </button>
        </div>

        <TrackingSearch />
      </div>
      
      <div className="suggestionsContainer">
        <SuggestionsCarousel />
      </div>
      
      <div className="mainLink" onClick={handleEInteriorClick}>
        <p>Δες περισσότερα εδώ</p>
        <img src={BottomLogo} className="site-logo" alt="e-interior" />
      </div>
      
      <div className="artivelab">
        Powered by{' '}
        <a 
          href="https://artivelab.com/el" 
          target="_blank"
          rel="noopener noreferrer"
          title="Κατασκευή eshop, ιστοσελίδων και custom εφαρμογών"
        >
          Artivelab.com
        </a>
      </div>

      {/* Service Request Modal */}
      <ServiceRequestModal isOpen={isModalOpen} onClose={closeModal} />
    </div>
  );
}

export default App;
